module.exports = __webpack_public_path__ + "static/media/ic_peravaunu_b.1134c9bb.svg";


//////////////////
// WEBPACK FOOTER
// ./src/map/images/ic_peravaunu_b.svg
// module id = 1169
// module chunks = 0